import React from 'react';
import OuiNonToggle from './oui-non-toggle.js';
import CaptureDetailsTable from './capture-details-table.js';
import {
    estQuestionAutreEspeceResolue,
    montrerQuestionAutreEspeceRound,
    obtenirReponseAutreEspeceRound,
    doitAfficherSaisieEspeceActive,
} from '../../utils/fermer-enregistrement-peche-capture.js';
import { obtenirIdsRoundsBloc } from '../../utils/fermer-enregistrement-capture.js';

const hasPositiveCount = (value) => Number(value) > 0;

const PointEauSection = ({
    texts,
    index,
    block,
    pointsEauxDisponibles,
    isFirst,
    showAutrePointEau,
    onPointEauChange,
    onNombrePersonnesChange,
    onNombreJoursChange,
    onPrisesChange,
    onCaptureDetailChange,
    onAutreEspeceChange,
    onEspeceChange,
    onAutrePointEauChange,
}) => {
    const pointLabel = isFirst
        ? texts.pointEauFirst
        : texts.pointEauOther;

    const showNombreJours = block.idPointEau && hasPositiveCount(block.nombrePersonnes);
    const afficherQuestionPrises = showNombreJours && (
        hasPositiveCount(block.nombreJours) || block.aEuDesPrises !== null
    );
    const canShowAutrePointEau = showAutrePointEau && estQuestionAutreEspeceResolue(block);
    const excludedSpeciesIds = obtenirIdsRoundsBloc(block);
    const especeRounds = block.especeRounds || [];
    const showActiveSpeciesCapture = doitAfficherSaisieEspeceActive(block);

    const activeSpeciesCaptureTable = showActiveSpeciesCapture &&
        <CaptureDetailsTable
            texts={texts}
            capturesDetails={block.capturesDetails}
            excludeSpeciesIds={excludedSpeciesIds}
            resetSelectionKey={excludedSpeciesIds.join('|')}
            activeSpeciesId={block.activeEspeceId || ''}
            showInstruction={especeRounds.length === 0}
            onSpeciesChange={speciesId => onEspeceChange(index, speciesId)}
            onDetailChange={(detailIndex, field, value, extraUpdates) =>
                onCaptureDetailChange(index, detailIndex, field, value, extraUpdates)
            }
        />;

    return (
        <div className="fec-point-eau-section">
            <div className="sub-title-section">
                <span className="droit-acces-span">{pointLabel}</span>
            </div>
            <select
                className="fec-select droit-acces-input"
                value={block.idPointEau || ''}
                onChange={e => onPointEauChange(index, e.target.value)}
            >
                <option value="">{texts.chooseOption}</option>
                {pointsEauxDisponibles.map(pe => (
                    <option key={pe.idPointEau} value={pe.idPointEau}>
                        {pe.description}
                    </option>
                ))}
            </select>

            {block.idPointEau &&
                <>
                    <div className="sub-title-section">
                        <span className="droit-acces-span">{texts.nombrePersonnes}</span>
                    </div>
                    <input
                        type="number"
                        min="1"
                        className="fec-number-input droit-acces-input"
                        value={block.nombrePersonnes}
                        onChange={e => onNombrePersonnesChange(index, e.target.value)}
                        onWheel={(e) => e.currentTarget.blur()}

                    />

                    {showNombreJours &&
                        <>
                            <div className="sub-title-section">
                                <span className="droit-acces-span">{texts.nombreJours}</span>
                            </div>
                            <input
                                type="number"
                                min="1"
                                className="fec-number-input droit-acces-input"
                                value={block.nombreJours}
                                onChange={e => onNombreJoursChange(index, e.target.value)}
                                onWheel={(e) => e.currentTarget.blur()}
                            />
                        </>
                    }

                    {afficherQuestionPrises &&
                        <OuiNonToggle
                            texts={texts}
                            label={texts.prisesQuestion}
                            value={block.aEuDesPrises}
                            onChange={value => onPrisesChange(index, value)}
                        />
                    }

                    {block.aEuDesPrises === true &&
                        <div className="fec-capture-flow">
                            {especeRounds.map((round, roundIndex) =>
                                <React.Fragment key={`espece-round-${round.speciesId}`}>
                                    <CaptureDetailsTable
                                        texts={texts}
                                        capturesDetails={block.capturesDetails}
                                        lockSpeciesDropdown={true}
                                        lockedSpeciesId={round.speciesId}
                                        showInstruction={false}
                                        onDetailChange={(detailIndex, field, value, extraUpdates) =>
                                            onCaptureDetailChange(index, detailIndex, field, value, extraUpdates)
                                        }
                                    />

                                    {montrerQuestionAutreEspeceRound(block, roundIndex) &&
                                        <OuiNonToggle
                                            texts={texts}
                                            label={texts.autreEspeceQuestion}
                                            value={obtenirReponseAutreEspeceRound(block, roundIndex)}
                                            onChange={value => onAutreEspeceChange(index, value, roundIndex)}
                                        />
                                    }
                                </React.Fragment>
                            )}

                            {activeSpeciesCaptureTable}
                        </div>
                    }

                    {block.aEuDesPrises !== null && canShowAutrePointEau &&
                        <OuiNonToggle
                            texts={texts}
                            label={texts.autrePointEau}
                            value={block.autrePointEau}
                            onChange={value => onAutrePointEauChange(index, value)}
                        />
                    }
                </>
            }
        </div>
    );
};

export default PointEauSection;
